module.exports = __webpack_public_path__ + "media/src/img/children-right-deco-35e34ac96215a612aa9b34b412feea6a.png";